export const CRYPTO_PORTFOLIO_FEATURE = () => "access To crypto-wise portfolio"
export const CATEGORY_PORTFOLIO_FEATURE = () => "category-wise best portfolios"
export const ORDER_BOOK_PORTFOLIO_FEATURE = () => "access to top portfolio orderbook"
export const RECOMMENDATION = () => "recommendations"
export const PERFORMANCE_SUMMARY_FEATURE = () => "access to portfolio analysis"
export const PERFORMANCE_TRACKER = () => "access to portfolio performance tracker"
export const INDICES_COMPOSITION_AND_CHANGE = () => "access to indices composition and change in index"
export const BEST_PREDICTION_PAGE = () => "access to best prediction page"